import { render, staticRenderFns } from "./SaveStateTag.vue?vue&type=template&id=1f2447a3&"
import script from "./SaveStateTag.vue?vue&type=script&lang=js&"
export * from "./SaveStateTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports